import { pick, prop } from 'ramda';
import { useCallback } from 'react';
import { get } from 'js/utils/fetch.util';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

export const useGetMenuConfigAsync = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const lang = useUserSelector(prop('lang'));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const { menuItems, requestStamp } = useAppSelector(pick(['menuItems', 'requestStamp']));

    return useCallback(async (disableCache) => {
        let response = { menuItems };

        if (!menuItems.length || disableCache) {
            const requestURL = getCMSResourceURL(`/initialResources/menu/${lang}_${formFactor}`, { t: requestStamp || Date.now() });

            response = await get(requestURL);
        }

        return response;
    }, [formFactor, lang, menuItems, requestStamp, getCMSResourceURL]);
};
